import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Dashboard from './Pages/Dashboard';
import MyAccount from './Pages/MyAccount';
import Layout from './Layout/Layout';
import Login from './Pages/LoginScreen';
import { useAppSelector, useAppDispatch } from './hooks';
import { refreshAppBootstrap } from './Redux/bootstrap/bootstrapSlice';
import Loading from './Components/Loading';
import SellAThonReport from './Features/SalesDep/Sales/SellAThonReport';
import SalesReport from './Pages/SalesReport';
import NudgeReport from './Features/SalesDep/Nudges/Nudge';
import NudgeDetail from './Features/SalesDep/Nudges/NudgeDetail';
import MSDS from './Features/Shared/Products/MSDS';
import SalesRepView from './Features/SalesDep/Managers/SalesRepView/SalesRepView';
import { analytics } from './firebase';
import CRMEntry from './Features/SalesDep/CRM/CRMEntry';
import AnalyticsTracker from './AnalyticsTracker';
import PIMAgent from './Features/Shared/PIM Agent/PIMAgent';
import Promotions from './Pages/Promotions';
import CustomerReport from './Features/Shared/Customers/CustomerReport';
import CustomerDetails from './Features/Shared/Customers/CustomerDetails';
import CRMActions from './Features/SalesDep/CRM/CRMActions';
import Locations from './Pages/Locations';
import LocationDetail from './Features/Shared/Locations/LocationDetail';
import AskJiro from './Features/Shared/AskJiro/AskJiro';
import Orders from './Pages/Orders';
import OrderDetail from './Features/SalesDep/Orders/OrderDetails';
import ProductDetail from './Features/Shared/Products/ProductDetail';
import BidDetails from './Features/SalesDep/Bids/BidDetails';
import TodoList from './Features/SalesDep/To-Do List/TodoReport';
import { initWebNotifications } from './Features/Shared/Push Notifications/webNotifications';

function App() {
    const { isAuthorized, token } = useAppSelector((state) => state.auth);
    const loading = useAppSelector((state) => state.bootstrap.loading);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const fetchData = async () => {
            if (isAuthorized && token) {
                try {
                    await Promise.all([
                        dispatch(refreshAppBootstrap())
                    ])

                    initWebNotifications(dispatch);
                    
                } catch (err: any) {
                    console.error('API Call Fail:', err.message)
                }
            }
        }
        fetchData();
    }, [dispatch, isAuthorized, token]);

    if (loading) {
        return (
            <Loading />
        )
    };

    return (
        <div className="App bg-light min-vh-100">
            <AnalyticsTracker />
            <Routes>
                {!isAuthorized ? (
                    <>
                        <Route path='/login' element={<Login />} />
                        <Route path='*' element={<Navigate to='/login' replace />} />
                    </>
                ) : (
                    <Route element={<Layout />}>
                        <Route path='/Dashboard' element={<Dashboard />} />
                        <Route path='/TodoList' element={<TodoList />} />
                        <Route path='/Orders+Bids' element={<Orders />} />
                        <Route path='/Orders+Bids/OrderDetail/:orderId' element={<OrderDetail />} />
                        <Route path='/Orders+Bids/BidDetails/:quoteId' element={<BidDetails />} />
                        <Route path='/ProductDetail/:productId' element={<ProductDetail />} />
                        <Route path='/SalesRepView' element={<SalesRepView />}/>
                        <Route path='/SalesRepView' element={<SalesRepView />}/>
                        <Route path='/MyAccount' element={<MyAccount />} />
                        <Route path='/SellAThon' element={<SellAThonReport />} />
                        <Route path='/SalesReport' element={<SalesReport />} />
                        <Route path='/Promotions' element={<Promotions />} />
                        <Route path='/CrmEntry' element={<CRMEntry />} />
                        <Route path='/PIM' element={<PIMAgent />} />
                        <Route path='/AskJiro' element={<AskJiro />} />
                        <Route path='/Nudges' element={<NudgeReport />} />
                        <Route path='/Nudges/:nudgeId' element={<NudgeDetail />} />
                        <Route path='/Locations' element={<Locations />} />
                        <Route path='/Locations/:locationId' element={<LocationDetail />} />
                        <Route path='/Customers' element={<CustomerReport />} />
                        <Route path='/Customers/:customerId' element={<CustomerDetails />} />
                        <Route path='/Customers/:customerId/CRMActions' element={<CRMActions />} />
                        <Route path='/SDS' element={<MSDS />} />
                        <Route path='/login' element={<Navigate to='/Dashboard' replace />} />
                        <Route path='/' element={<Navigate to='/Dashboard' replace />} />
                    </Route>
                )}
            </Routes>
        </div>
    );
}

export default App;
